import axiosInstance from "api/axiosInstance";

import type { DashboardStats, InstructorMonthlyStats, PracticeMonthlyStats } from "api/types/dashboard.types";

export const dashboardService = {
  getOrderStats: () => axiosInstance.get<DashboardStats>("/server/buccl_main/api/v1/admin/orders/dashboard/stats/"),

  getPracticeMonthlyStats: (year: number, month: number) => axiosInstance.get<PracticeMonthlyStats>("/server/buccl_payment/api/v1/practice-records/monthly_stats/", { params: { year, month } }),

  getInstructorMonthlyStats: (year: number, month: number, instructorId?: number) => axiosInstance.get<InstructorMonthlyStats>("/server/buccl_payment/api/v1/records/monthly_stats/", { params: { year, month, ...(instructorId ? { instructor_id: instructorId } : {}) } }),
};
